import { Stack } from '@mantine/core';
import { useMemo } from 'react';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { setSelectedCapacityTeams } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useSelectedCapacityTeams } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { CapacityItem } from './capacity-item';

export const Capacity = () => {
  const portfolio = useGlobalStore((state) => state.portfolio);
  const selectedCapacityTeams = useSelectedCapacityTeams();

  const teams = portfolio?.projects || [];
  const teamIds = useMemo(() => teams.map((team) => team.id), [teams]);

  if (!teams.length) {
    return null;
  }

  return (
    <Stack pb={40}>
      {teams.map((team) => (
        <CapacityItem key={team.id} team={team} isSelected={selectedCapacityTeams.includes(team.id)} />
      ))}
      <ResetFiltersButton onClick={() => setSelectedCapacityTeams(teamIds)} />
    </Stack>
  );
};
